export default "<p>simple-quiz works!</p>\n";